import React from 'react';
import { Button } from '@material-ui/core';
import Modal from 'components/Modal';
import clsx from 'clsx';
import classes from './Modal.module.scss';

const DeleteModal = ({
  open,
  title,
  item,
  actionDeleteName,
  body,
  handleClose,
  onDelete,
  isDanger = true,
}) => {
  return (
    <Modal
      modalProps={{
        className: { classRoot: clsx(classes.root, classes['root--danger']) },
        open,
        handleClose: () => {
          handleClose();
        },
        title,
        size: 'small',
        footer: (
          <>
            <Button
              className={isDanger ? classes.dangerButton : classes.button}
              color='primary'
              variant='contained'
              onClick={() => {
                onDelete(item);
              }}>
              {actionDeleteName || 'Delete'}
            </Button>
            <Button
              className={classes.defaultButton}
              variant='outlined'
              onClick={() => {
                handleClose();
              }}>
              Cancel
            </Button>
          </>
        ),
      }}>
      {body}
    </Modal>
  );
};

export default DeleteModal;
